export const DOC_COLUMNS = [
  {
    label: "Tên văn bản",
    field: "name",
    width: 300,
  },
  {
    label: "Số",
    field: "number",
    width: 100,
  },
  {
    label: "Loại",
    field: "type",
    width: 300,
  },
  {
    label: "Ngày",
    field: "date",
    sort: "asc",
    width: 100,
  },
  {
    label: "Link",
    field: "url",
    sort: "disabled",
    width: 150,
  },
  {
    label: "Trạng thái",
    field: "status",
    width: 100,
  },
];

export const DOC_ROWS = [
  {
    no: 1,
    name: "KẾ HOẠCH TỔ CHỨC CUỘC THI HỌC THUẬT TRUYỀN THỐNG MIT - 2026",
    number: 1,
    type: "KHLT-ĐTN-HSV",
    date: "2026/04/17",
    url: "https://drive.google.com/file/d/1T4OpB6tyuiJDJboj3rMzmwMh9ybXnmhv/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 2,
    name: "KẾ HOẠCH Bí mật Sài thành 2026 chủ đề “Theo bước chân người”",
    number: 1,
    type: "KHLT-ĐTN-HSV",
    date: "2026/05/04",
    url: "https://drive.google.com/file/d/1uw_2BG9AefQZiBP7TFsBxCbMBM2T_aeM/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 3,
    name: "Tổ chức cuộc thi kể chuyện về Bác chào mừng kỷ niệm 136 năm ngày sinh Chủ tịch Hồ Chí Minh (19/5/1890 – 19/5/2026)",
    number: 1,
    type: "KHLT-ĐTN-HSV",
    date: "2026/05/05",
    url: "https://drive.google.com/file/d/17HZCUzeL2VH4Rw7D6BVSiQZvwzgM5t7R/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 4,
    name: "KẾ HOẠCH Tổ chức Lễ kỷ niệm 25 năm thành lập Đoàn thanh niên - Hội sinh viên khoa Công nghệ Thông tin (23/3/2001 - 23/3/2026)",
    number: 1,
    type: "KHLT-ĐTN-HSV-CNTT",
    date: "2026/3/02",
    url: "https://drive.google.com/file/d/1ueyFg2bqTwXFGVROLgHrk9cZAjvi4mAZ/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 5,
    name: "KẾ HOẠCH Tổ chức Cuộc thi “Tìm hiểu lịch sử Đoàn TNCS Hồ Chí Minh và lịch sử Đoàn TNCS Hồ Chí Minh trường Đại học Công Nghệ kỹ thuật Tp. HCM” năm 2026",
    number: 2,
    type: "KH/ĐTN-CNTT",
    date: "2022/11/07",
    url: "https://drive.google.com/file/d/1SQAhdwIWkl1uKpTyp_CeGSmbYaD4niIF/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 2,
    name: 'KẾ HOẠCH Tổ chức cuộc thi thiết kế video Tiktok "Tự hào sinh viên HCMUTE — 76 năm về Yang Bé Cầu Tring"',
    number: 2,
    type: "KH-HSV-CNTT",
    date: "2026/01/06",
    url: "https://drive.google.com/file/d/1LMrBsmjpgoCxIubP2W3m3lu7lpgl4iFx/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 3,
    name: "KẾ HOẠCH IT SÁNG TẠO 2025",
    number: 3,
    type: "KH/ĐTN-CNTT",
    date: "2025/11/10",
    url: "https://drive.google.com/file/d/1mmkrnBm8qpmo9OhpIuwa0kNTop64WS3V/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 1,
    name: "KẾ HOẠCH TỌA ĐÀM 80 NĂM CÁCH MẠNG THÁNG 8 VÀ QUỐC KHÁNH 2/9 NĂM 2026 KHOA CÔNG NGHỆ THÔNG TIN",
    number: 6,
    type: "KH-HSV-CNTT",
    date: "2026/08/22",
    url: "https://drive.google.com/file/d/1-SbB7MAxMlAvyiKPyRHmiiOxvJiAB8Mk/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 2,
    name: "KẾ HOẠCH Tổ chức cuộc thi học thuật Hackathon mở rộng năm 2022 Khoa Công nghệ Thông tin",
    number: 5,
    type: "KH/ĐTN-CNTT",
    date: "2022/02/22",
    url: "https://docs.google.com/document/d/1lJXEWdb9yyQoEuYTVKG119NhYn55ryrt/edit?usp=sharing&ouid=115258241827326023436&rtpof=true&sd=true",
    status: "Đã ký",
  },
  {
    no: 3,
    name: "TRUNG THU YÊU THƯƠNG NĂM 2026",
    number: 11,
    type: "KH-HSV-CNTT",
    date: "2026/09/15",
    url: "https://drive.google.com/file/d/1JTn-M7g4JcGGhugWKeia-ohGJuzD2ca0/view?usp=sharing",
    status: "Đã ký",
  },
  {
    no: 4,
    name: "KẾ HOẠCH Tổ chức chương trình “Noel ấm áp” năm 2021 Khoa Công nghệ Thông tin",
    number: 4,
    type: "KHLT-ĐTN-HSV",
    date: "2021/12/20",
    url: "https://docs.google.com/document/d/18prwHNYCsg7VL4vxrD-MHKG7m00NQpOK/edit?usp=sharing&ouid=115258241827326023436&rtpof=true&sd=true",
    status: "Đã ký",
  },
  {
    no: 5,
    name: "KẾ HOẠCH Tổ chức chương trình “ IT SÁNG TẠO” năm 2021 Kỷ niệm 39 năm ngày Nhà giáo Việt Nam (20/11/1982 - 20/11/2021) Khoa Công nghệ Thông tin",
    number: 3,
    type: "KH-HSV-CNTT",
    date: "2021/10/28",
    url: "https://docs.google.com/document/d/1HrEqcLhoB8oFYyCoPfw_CEFRUN72VMdq/edit?usp=sharing&ouid=115258241827326023436&rtpof=true&sd=true",
    status: "Đã ký",
  },
  {
    no: 6,
    name: "KẾ HOẠCH Tổ chức chương trình “Thể dục Online - Say bye Covid” Khoa Công nghệ Thông tin năm 2021",
    number: 8,
    type: "KHLT-ĐTN-HSV-CNTT",
    date: "2021/08/05",
    url: "https://docs.google.com/document/d/14YXNbenuuBiOJzJ9gSLPZVbzLAUnUL8i/edit?usp=sharing&ouid=115258241827326023436&rtpof=true&sd=true",
    status: "Đã ký",
  },
  {
    no: 7,
    name: "KẾ HOẠCH Tổ chức chương trình “Trung thu yêu thương” năm 2021 Khoa Công nghệ Thông tin",
    number: 4,
    type: "KHLT-ĐTN-HSV",
    date: "2021/08/30",
    url: "https://docs.google.com/document/d/1gXmeQN6_JaK8DdKhu43Aa1hi1_x97n6t/edit?usp=sharing&ouid=115258241827326023436&rtpof=true&sd=true",
    status: "Đã ký",
  },
];
